const module = {
  firestorePath: 'banners',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'banner',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      category: {},
      subcategory: {},
      business: {},
      author: {},
      sales: {},
      showOnHomePage: false,
      dateRegister: null,
      dateExpired: null,
      dateRenewal: null,
      priceRegister: 0,
      priceRenewal: 0,
      billingCycle: 12,
      imageUrl: '',
      customActionUrl: '',
      status: '',
      isDeleted: false
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => {
      let data = []

      for (const key in state.data) {
        if (state.data.hasOwnProperty(key)) {
          data.push(state.data[key]);
        }
      }

      return data
    }
  },
  mutations: {},
  actions: {},
}

export default module
